export default __webpack_public_path__ + "static/media/a3ace5fd461d77a7.df0200b016926e5950c04ba92e98f6e4.svg";